// extracted by mini-css-extract-plugin
export var bodyRow = "_fl-d";
export var cardColumns = "_fl-e";
export var ellipsesOverflow = "_fl-2";
export var flatBottomCorners = "_fl-3";
export var flatTopCorners = "_fl-4";
export var headerActionsDropdown = "_fl-f";
export var headerBottomRow = "_fl-c";
export var headerTopRow = "_fl-b";
export var orderDetailsWrapper = "_fl-0";
export var orderInfoContainer = "_fl-1";
export var productDetails = "_fl-9";
export var productImage = "_fl-5";
export var responsiveTable = "_fl-8";
export var shipmentContainer = "_fl-a";
export var tableBottomLeft = "_fl-6";
export var tableBottomRight = "_fl-7";
export var trackingLink = "_fl-g";